import { Box } from "@mui/material";
import { DotLegalDialog, DotLegalMultiSelect, DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useRiskConsequenceDialogDataMapping } from "./RiskConsequenceDialog.hooks";
import { RiskConsequenceSaveModel } from "./RiskConsequenceDialog.types";
import DialogHeaderWithInformation from "@common/components/dialogHeaderWithInformation/DialogHeaderWithInformation";

export interface IRiskConsequenceDialog {
    onHideDialog: () => void;
    onSave: (response: string) => void;
    selectedRiskConsequence: RiskConsequenceSaveModel | undefined;
}

function RiskConsequenceDialog(props: IRiskConsequenceDialog) {
    const { translateString } = useTranslation();
    const {
        inProgress,
        viewModel,
        errors,
        isEdit,
        setName,
        setDescription,
        setCategory,
        setRiskAreas,
        chosenRiskAreas,
        categoryOptions,
        riskAreaOptions,
        riskAreasLoading,
        validateAndSave,
    } = useRiskConsequenceDialogDataMapping(props);

    return (
        <DotLegalDialog
            inProgress={inProgress}
            buttonOkText={isEdit() ? translateString("save") : translateString("create")}
            header={
                <DialogHeaderWithInformation
                    header={isEdit() ? translateString("editRiskConsequence") : translateString("createRiskConsequence")}
                    information={isEdit() ? undefined : translateString("riskConsequenceInfo")}
                />
            }
            onOkClick={validateAndSave}
            onDialogClose={props.onHideDialog}
            open
            disableBackdropOnCloseIfValueChange={viewModel}
            size="sm"
        >
            <Box sx={{ marginRight: 3 }}>
                <DotLegalTextField
                    debounce={false}
                    size="small"
                    label={translateString("riskConsequence")}
                    value={viewModel.name}
                    onChange={setName}
                    errorText={errors.nameError}
                    toolTipText={translateString("riskConsequenceInfo")}
                />
                <DotLegalTextField
                    debounce={false}
                    size="small"
                    multiline
                    rows={4}
                    label={translateString("description")}
                    value={viewModel.description ?? ""}
                    onChange={setDescription}
                />
                <DotLegalSelect
                    label={translateString("category")}
                    options={categoryOptions}
                    selectedItem={viewModel.category}
                    onChange={setCategory}
                    errorText={errors.categoryError}
                    noOptionsLabel={translateString("noOptions")}
                />
                <DotLegalMultiSelect
                    label={translateString("riskAreas")}
                    options={riskAreaOptions}
                    chosenOptions={chosenRiskAreas}
                    onChange={setRiskAreas}
                    isLoading={riskAreasLoading}
                    noOptionsLabel={translateString("noOptions")}
                />
            </Box>
        </DotLegalDialog>
    );
}

export default RiskConsequenceDialog;
